// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#trackingListDetils {
  /* In styles.css or tnt-tracking-list-details.component.scss */
}
#trackingListDetils .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,
#trackingListDetils .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close,
#trackingListDetils .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close,
#trackingListDetils .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {
  position: absolute;
  right: 4px;
  top: 4px;
  color: #828282;
}
#trackingListDetils .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close .pi,
#trackingListDetils .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close .pi,
#trackingListDetils .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close .pi,
#trackingListDetils .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close .pi {
  font-weight: bold;
}
#trackingListDetils .flex-row {
  display: flex;
  flex-direction: row;
}
#trackingListDetils .flex-row {
  display: flex;
  flex-direction: row;
  width: 100%;
}
#trackingListDetils .flex-grow-1 {
  flex: 0 0 75%;
}
#trackingListDetils .flex-grow-0 {
  flex: 0 0 25%;
}
#trackingListDetils .card {
  flex: 1;
}
#trackingListDetils .font-size-header {
  display: flex;
  align-items: baseline;
  font-size: 1rem;
  color: #1d2125;
  font-weight: normal;
}
#trackingListDetils .font-size-header button {
  font-size: 10px;
  width: 2rem;
  margin-top: 4px;
}
#trackingListDetils .font-size-header button ::ng-deep .pi-chevron-right {
  font-size: 10px;
  line-height: 9px;
}
#trackingListDetils .cursor {
  cursor: pointer;
}
#trackingListDetils .bdp-map-wrapper {
  position: relative;
}
#trackingListDetils .bdp-map-wrapper #bdpDraggableWrapper {
  overflow: hidden;
}
#trackingListDetils .bdp-map-wrapper #tntDetailedMap {
  height: 500px;
}
#trackingListDetils .bdp-map-wrapper .ng-resizable-handle.ng-resizable-s {
  height: 15px;
}
#trackingListDetils .bdp-map-wrapper .ng-resizable-handle.ng-resizable-s::after {
  /* width: 46px; */
  /* height: 0px; */
  content: "";
  /* margin-left: auto; */
  /* margin-right: 10px; */
  /* display: block; */
  /* margin-top: 3px; */
  /* border-bottom: 7px solid #d3d3d4; */
  float: right;
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 30px solid transparent;
  border-right: 12px solid #c9c9d0;
  cursor: n-resize;
}
#trackingListDetils .bdp-map-wrapper .bdp-switch-wrapper {
  position: absolute;
  bottom: 24px;
  left: 25px;
  background: #fff;
  padding: 4px 5px 2px 5px;
  border-radius: 5px;
}
#trackingListDetils .bdp-map-wrapper .bdp-switch-wrapper > span {
  float: right;
  margin-left: 15px;
}
#trackingListDetils ::ng-deep button.p-button {
  background-color: var(--bdpButtonSecondary);
  color: var(--bdpFontPrimary);
  border: 1px solid #d7d8d9;
}
#trackingListDetils ::ng-deep button.p-button.bdp-export-button {
  width: 36px;
  height: 36px;
  margin-left: 1rem;
}
#trackingListDetils ::ng-deep .p-inputswitch {
  height: 16px;
  width: 37px;
}
#trackingListDetils ::ng-deep .p-inputswitch .p-inputswitch-slider:before {
  width: 0.81rem;
  height: 0.81rem;
  top: 11px;
}
#trackingListDetils .badge-container {
  position: absolute;
  top: 7px;
  left: 30px;
  display: flex;
  gap: 4px;
}
#trackingListDetils .badge {
  padding: 4px 5px;
  border-radius: 20px;
  color: #fff;
  font-weight: bold;
}
#trackingListDetils .badge,
#trackingListDetils .flight-number {
  padding: 5px 10px;
  font-weight: bold;
}
#trackingListDetils .flight-number {
  color: #333;
}
#trackingListDetils .badge-not-started {
  color: var(--bdpInactive);
  border-color: var(--bdpInactive);
  border: 1px solid;
}
#trackingListDetils .badge-in-transit {
  color: #03a17b;
  border-color: #03a17b;
  border: 1px solid;
}
#trackingListDetils .badge-arrived {
  color: var(--bdpInactive);
  border-color: var(--bdpInactive);
  border: 1px solid;
}
#trackingListDetils .badge-inactive {
  color: var(--bdpInactive);
  border-color: var(--bdpInactive);
  border: 1px solid;
}
#trackingListDetils .badge-doc-only {
  color: #2d74ff;
  border-color: #2d74ff;
  border: 1px solid;
}
#trackingListDetils .badge-live-track-pending {
  color: #d32f2f;
  border-color: #d32f2f;
  border: 1px solid;
}
#trackingListDetils .badge-ontime {
  background-color: var(--bdpOntime);
}
#trackingListDetils .badge-late {
  background-color: var(--bdpDelay);
}
#trackingListDetils .badge-early {
  background-color: var(--bdpEarly);
}
#trackingListDetils .icon-container:hover i {
  color: #2d74ff;
}
#trackingListDetils .timeline-container {
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  /* Custom scrollbar styling */
}
#trackingListDetils .timeline-container::-webkit-scrollbar {
  width: 8px;
}
#trackingListDetils .timeline-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}
#trackingListDetils .timeline-container::-webkit-scrollbar-thumb {
  background: e4e5e5;
  border-radius: 4px;
}
#trackingListDetils .timeline-container::-webkit-scrollbar-thumb:hover {
  background: e4e5e5;
}`, "",{"version":3,"sources":["webpack://./src/app/direct-link/direct-link-shipment-tracking-details/direct-link-shipment-tracking-details.component.scss"],"names":[],"mappings":"AAAA;EAyII,8DAAA;AAvIJ;AAAI;;;;EAII,kBAAA;EACA,UAAA;EACA,QAAA;EACA,cAAA;AAER;AAAQ;;;;EACI,iBAAA;AAKZ;AADI;EACI,aAAA;EACA,mBAAA;AAGR;AACI;EACI,aAAA;EACA,mBAAA;EACA,WAAA;AACR;AAEI;EACI,aAAA;AAAR;AAGI;EACI,aAAA;AADR;AAII;EACI,OAAA;AAFR;AAKI;EACI,aAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,mBAAA;AAHR;AAKQ;EACI,eAAA;EACA,WAAA;EACA,eAAA;AAHZ;AAKY;EACI,eAAA;EACA,gBAAA;AAHhB;AAQI;EACI,eAAA;AANR;AASI;EACI,kBAAA;AAPR;AASQ;EACI,gBAAA;AAPZ;AAUQ;EACI,aAAA;AARZ;AAYQ;EACI,YAAA;AAVZ;AAYY;EACI,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,uBAAA;EACA,wBAAA;EACA,oBAAA;EACA,qBAAA;EACA,sCAAA;EACA,YAAA;EACA,QAAA;EACA,SAAA;EACA,kCAAA;EACA,qCAAA;EACA,gCAAA;EACA,gBAAA;AAVhB;AAcQ;EACI,kBAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,wBAAA;EACA,kBAAA;AAZZ;AAcY;EACI,YAAA;EACA,iBAAA;AAZhB;AAkBQ;EACI,2CAAA;EACA,4BAAA;EACA,yBAAA;AAhBZ;AAkBY;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAhBhB;AAoBQ;EACI,YAAA;EACA,WAAA;AAlBZ;AAoBY;EACI,cAAA;EACA,eAAA;EACA,SAAA;AAlBhB;AAwBI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,QAAA;AAtBR;AAyBI;EACI,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,iBAAA;AAvBR;AA0BI;;EAEI,iBAAA;EAEA,iBAAA;AAzBR;AA6BI;EACI,WAAA;AA3BR;AAmCI;EACI,yBAAA;EACA,gCAAA;EACA,iBAAA;AAjCR;AAoCI;EACI,cAAA;EACA,qBAAA;EACA,iBAAA;AAlCR;AAqCI;EACI,yBAAA;EACA,gCAAA;EACA,iBAAA;AAnCR;AAsCI;EACI,yBAAA;EACA,gCAAA;EACA,iBAAA;AApCR;AAuCI;EACI,cAAA;EACA,qBAAA;EACA,iBAAA;AArCR;AAuCI;EACI,cAAA;EACA,qBAAA;EACA,iBAAA;AArCR;AAuCI;EACI,kCAAA;AArCR;AAwCI;EACI,iCAAA;AAtCR;AAyCI;EACK,iCAAA;AAvCT;AA0CI;EACI,cAAA;AAxCR;AA2CI;EACI,aAAA;EACA,gBAAA;EACA,kBAAA;EAEA,6BAAA;AA1CR;AA2CQ;EACI,UAAA;AAzCZ;AA4CQ;EACI,mBAAA;EACA,kBAAA;AA1CZ;AA6CQ;EACI,kBAAA;EACA,kBAAA;AA3CZ;AA6CY;EACI,kBAAA;AA3ChB","sourcesContent":["#trackingListDetils {\n\n    .p-toast .p-toast-message.p-toast-message-success .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-info .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-warn .p-toast-icon-close,\n    .p-toast .p-toast-message.p-toast-message-error .p-toast-icon-close {\n        position: absolute;\n        right: 4px;\n        top: 4px;\n        color: #828282;\n\n        .pi {\n            font-weight: bold;\n        }\n    }\n\n    .flex-row {\n        display: flex;\n        flex-direction: row;\n        //  gap: 1rem; /* Optional: adds space between the cards */\n    }\n\n    .flex-row {\n        display: flex;\n        flex-direction: row;\n        width: 100%;\n    }\n\n    .flex-grow-1 {\n        flex: 0 0 75%;\n    }\n\n    .flex-grow-0 {\n        flex: 0 0 25%;\n    }\n\n    .card {\n        flex: 1;\n    }\n\n    .font-size-header {\n        display: flex;\n        align-items: baseline;\n        font-size: 1rem;\n        color: #1d2125;\n        font-weight: normal;\n\n        button {\n            font-size: 10px;\n            width: 2rem;\n            margin-top: 4px;\n\n            ::ng-deep .pi-chevron-right {\n                font-size: 10px;\n                line-height: 9px;\n            }\n        }\n    }\n\n    .cursor {\n        cursor: pointer;\n    }\n\n    .bdp-map-wrapper {\n        position: relative;\n\n        #bdpDraggableWrapper {\n            overflow: hidden;\n        }\n\n        #tntDetailedMap {\n            height: 500px;\n        }\n\n\n        .ng-resizable-handle.ng-resizable-s {\n            height: 15px;\n\n            &::after {\n                /* width: 46px; */\n                /* height: 0px; */\n                content: \"\";\n                /* margin-left: auto; */\n                /* margin-right: 10px; */\n                /* display: block; */\n                /* margin-top: 3px; */\n                /* border-bottom: 7px solid #d3d3d4; */\n                float: right;\n                width: 0;\n                height: 0;\n                border-top: 10px solid transparent;\n                border-bottom: 30px solid transparent;\n                border-right: 12px solid #c9c9d0;\n                cursor: n-resize;\n            }\n        }\n\n        .bdp-switch-wrapper {\n            position: absolute;\n            bottom: 24px;\n            left: 25px;\n            background: #fff;\n            padding: 4px 5px 2px 5px;\n            border-radius: 5px;\n\n            &>span {\n                float: right;\n                margin-left: 15px;\n            }\n        }\n    }\n\n    ::ng-deep {\n        button.p-button {\n            background-color: var(--bdpButtonSecondary);\n            color: var(--bdpFontPrimary);\n            border: 1px solid #d7d8d9;\n\n            &.bdp-export-button {\n                width: 36px;\n                height: 36px;\n                margin-left: 1rem;\n            }\n        }\n\n        .p-inputswitch {\n            height: 16px;\n            width: 37px;\n\n            .p-inputswitch-slider:before {\n                width: 0.81rem;\n                height: 0.81rem;\n                top: 11px;\n            }\n        }\n    }\n\n    /* In styles.css or tnt-tracking-list-details.component.scss */\n    .badge-container {\n        position: absolute;\n        top: 7px;\n        left: 30px;\n        display: flex;\n        gap: 4px;\n    }\n\n    .badge {\n        padding: 4px 5px;\n        border-radius: 20px;\n        color: #fff;\n        font-weight: bold;\n    }\n\n    .badge,\n    .flight-number {\n        padding: 5px 10px;\n        // border-radius: 5px;\n        font-weight: bold;\n        // border: 1px solid;\n    }\n\n    .flight-number {\n        color: #333;\n    }\n\n    // .flight-number i {\n    //     margin-right: 5px;\n\n    // }\n\n    .badge-not-started {\n        color:var(--bdpInactive);\n        border-color: var(--bdpInactive);\n        border: 1px solid;\n    }\n\n    .badge-in-transit {\n        color: #03a17b;\n        border-color: #03a17b;\n        border: 1px solid;\n    }\n\n    .badge-arrived {\n        color: var(--bdpInactive);\n        border-color:var(--bdpInactive);\n        border: 1px solid;\n    }\n\n    .badge-inactive {\n        color:var(--bdpInactive);\n        border-color: var(--bdpInactive);\n        border: 1px solid;\n    }\n\n    .badge-doc-only {\n        color: #2d74ff;\n        border-color: #2d74ff;\n        border: 1px solid;\n    }\n    .badge-live-track-pending {\n        color: #d32f2f;\n        border-color: #d32f2f;\n        border: 1px solid;\n    }\n    .badge-ontime {\n        background-color: var(--bdpOntime);\n    }\n\n    .badge-late {\n        background-color: var(--bdpDelay);\n    }\n\n    .badge-early {\n         background-color: var(--bdpEarly);\n    }\n\n    .icon-container:hover i {\n        color: #2d74ff;\n    }\n\n    .timeline-container {\n        height: 500px;\n        overflow-y: auto;\n        overflow-x: hidden;\n        \n        /* Custom scrollbar styling */\n        &::-webkit-scrollbar {\n            width: 8px;\n        }\n        \n        &::-webkit-scrollbar-track {\n            background: #f1f1f1;\n            border-radius: 4px;\n        }\n        \n        &::-webkit-scrollbar-thumb {\n            background: e4e5e5;\n            border-radius: 4px;\n            \n            &:hover {\n                background: e4e5e5;\n            }\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
